// Hook to get the account platform from the URL
"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { useParams } from "next/navigation";
import { getPlatformForAccount } from "@/lib/utils";
export function useAccountPlatform() {
  const $ = _c(3);
  const params = useParams();
  const accountId = params?.accountId as string;
  const [platform, setPlatform] = useState("instagram");
  let t0;
  let t1;
  if ($[0] !== accountId) {
    t0 = () => {
      if (accountId) {
        const storedPlatform = getPlatformForAccount(accountId);
        setPlatform(storedPlatform);
      }
    };
    t1 = [accountId];
    $[0] = accountId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return platform;
}